<script>

    import { fade } from 'svelte/transition';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    let { delay = 500 } = $props();
    let announced = $state(false);

    onMount(() => {
        const timeout = setTimeout(() => announced = true, 1000);
        return () => clearTimeout(timeout);
    });

</script>


<div in:fade={{ delay: delay, duration: delay ? 200 : 0 }} role="status">
    {#if announced}
        <span class="sr-only">{$_('loading')}</span>
    {/if}
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" aria-hidden="true">
        <radialGradient id="a9" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
            <stop offset="0" stop-color="currentColor"></stop><stop offset=".3" stop-color="currentColor" stop-opacity=".9"></stop>
            <stop offset=".6" stop-color="currentColor" stop-opacity=".6"></stop>
            <stop offset=".8" stop-color="currentColor" stop-opacity=".3"></stop>
            <stop offset="1" stop-color="currentColor" stop-opacity="0"></stop>
        </radialGradient>
        
        <circle transform-origin="center" fill="none" stroke="url(#a9)" stroke-width="6" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
            <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
        </circle>
        
        <circle transform-origin="center" fill="none" opacity=".2" stroke="currentColor" stroke-width="6" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
    </svg>
</div>

<style>

    div {
        display: flex;
        margin-top: 9em;
        flex: 1;
    }

    svg {
        width: 64px;
        height: 64px;
        margin: 2em auto 0;
    }

</style>